import styled from "styled-components";

export const CarouselStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	.image-navigation {
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.navigation-button {
		background-color: transparent;
		border: none;
		cursor: pointer;
		font-size: 16px;
		padding: 5px 10px;
		border-radius: 5px;
		transition: background-color 0.3s ease;
	}
	img {
		max-width: 100%;
		height: auto;
		border-radius: 5px;
	}
`;
